// extracted by mini-css-extract-plugin
export default {"button":"styles_button__3tIZg","icon":"styles_icon__svEy7"};